import React, { useEffect } from "react";

import withAdminNavbar from "features/navbar/wrappers/withAdminNavbar";
import { useDispatch } from "services/redux/rootReducer";
import subscribeToAllProducts from "../actions/listeners/listener.subscribeToAllProducts";
import ProductEditorPage from "../screens/product";
import getAllTags from "features/tagEdit/actions/set/update/get.getAllTags";

const ProductRouter: React.FC = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        let unsubscribers: Array<() => void> = [];

        unsubscribers.push(dispatch(subscribeToAllProducts()));
        unsubscribers.push(dispatch(getAllTags())); // have to do this so all tags can be queried

        return () => {
            unsubscribers.forEach((unsubscriberFn) => unsubscriberFn());
        };
    }, [dispatch]);

    return withAdminNavbar(<ProductEditorPage />);
};

export default ProductRouter;
